const NON_PROJECT_PREFIXES = [
  "/dashboard/backoffice/",
  "/dashboard/bim/",
  "/dashboard/costs",
  "/dashboard/settings",
  "/dashboard/director/",
];

const NON_PROJECT_PATHS = new Set([
  "/dashboard/director",
]);

export const isProjectScopedPath = (pathname = "") => (
  !NON_PROJECT_PATHS.has(pathname)
  && !NON_PROJECT_PREFIXES.some((prefix) => pathname.startsWith(prefix))
);

export const projectIdFromPath = (pathname = "") => {
  if (!isProjectScopedPath(pathname)) return undefined;
  const parts = pathname.split("/").filter(Boolean);
  return parts.length > 1 && parts.at(-1) !== "dashboard" ? parts.at(-1) : undefined;
};

export const projectListOptions = (pathname = "") => ({
  selectActive: isProjectScopedPath(pathname),
});

export default { isProjectScopedPath, projectIdFromPath, projectListOptions };
